var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "our-advantages-table"
  }, [_c("List", {
    attrs: {
      dataList: _vm.dataListTop,
      height: "110px"
    }
  }), _c("List", {
    attrs: {
      dataList: _vm.dataListBottom
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };